import { ShipOrder } from '../ShipOrder';

import { ValidShipOrderShippingPoint } from './ValidShipOrderShippingPoint';

export class ValidShipOrder extends ShipOrder {
  id: number;
  origin: ValidShipOrderShippingPoint;
  destination: ValidShipOrderShippingPoint;

  constructor(opts?: Partial<ShipOrder>) {
    super(opts);

    if (opts?.id) {
      this.id = opts.id;
    } else {
      throw new Error('Invalid ShipOrder - id is required');
    }

    this.origin = new ValidShipOrderShippingPoint(opts?.origin);
    this.destination = new ValidShipOrderShippingPoint(opts?.destination);

    const lineItemLength = this.lineItems?.length || 0;
    if (lineItemLength < 1) {
      throw new Error('Invalid ShipOrder - at least 1 LineItem required');
    }
  }
}
